import ReportTabsPptSlide from './reportTabsPptSlide'
export default ReportTabsPptSlide
